import { Table, Tooltip } from "antd";
import React from "react";

function TableDeclarations(props) {
  const { category, handleTableChange, data, filters, totalItems, isLoading } =
    props;

  const withTooltip = (value, bold = false) => {
    const text = typeof value === "object" ? value?.props?.children : value;
    return (
      <Tooltip title={text}>
        <span style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: bold ? "bold" : undefined }}>
          {text}
        </span>
      </Tooltip>
    );
  };

  const columns = [
    {
      title: "Code Adhérent",
      dataIndex: "membershipCode",
      key: "membershipCode",
      align: "center",
      filteredValue: undefined,
      minWidth: 120,
    },
    {
      title: "Raison Sociale",
      dataIndex: "companyName",
      key: "companyName",
      align: "center",
      filteredValue: undefined,
      width: 220,
      ellipsis: true,
      render: (v) => withTooltip(v, true),
    },
    {
      title: "Date saisie",
      dataIndex: "formatedInputedDate",
      key: "formatedInputedDate",
      align: "center",
      filteredValue: undefined,
      minWidth: 110,
    },
    {
      title: "Type",
      dataIndex: "declarationType",
      key: "declarationType",
      align: "center",
      filters: [
        { text: "Mensuel", value: "monthly" },
        { text: "Semestriel S1", value: "semi_annual_s1" },
        { text: "Semestriel S2", value: "semi_annual_s2" },
        { text: "Annuel", value: "annual" },
      ],
      filteredValue: props.declarationType || null,
      minWidth: 120,
      render: (value) => {
        switch(value) {
          case "annual": return "Annuel";
          case "semi_annual_s1": return "Semestriel S1";
          case "semi_annual_s2": return "Semestriel S2";
          default: return "Mensuel";
        }
      },
    },
    {
      title: "Date de déclaration",
      dataIndex: "formatedValidatedDate",
      key: "formatedCreationDate",
      align: "center",
      filteredValue: undefined,
      minWidth: 140,
    },
    {
      title: "Montant",
      dataIndex: "feeAmount",
      key: "feeAmount",
      align: "right",
      filteredValue: undefined,
      minWidth: 90,
    },
    {
      title: "Effectifs",
      dataIndex: "workForce",
      key: "workForce",
      align: "right",
      filteredValue: undefined,
      minWidth: 90,
    },
    {
      title: "Statut",
      dataIndex: "status",
      key: "status",
      align: "center",
      filters: [
        { text: "Actif", value: "active" },
        { text: "Demande modification", value: "pending_modification" },
        { text: "Demande attestation", value: "pending_attestation" },
        { text: "Demande approuvée", value: "modification_approved" },
        { text: "Annulé", value: "cancelled" }
      ],
      filteredValue: props.status || null,
      minWidth: 130,
    },
    {
      title: "Méthode paiement",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      align: "center",
      filteredValue: undefined,
      minWidth: 140,
    },
    {
      title: "Réglé",
      dataIndex: "payed",
      key: "payes",
      align: "center",
      filteredValue: undefined,
      minWidth: 70,
    },
    {
      title: "Actions",
      key: "edit",
      dataIndex: "edit",
      filteredValue: undefined,
      fixed: "right",
      width: 100,
    },
    {
      title: "Actions Modification",
      key: "modificationActions",
      dataIndex: "modificationActions",
      align: "center",
      filteredValue: undefined,
      fixed: "right",
      width: 100,
    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      style={{ flexGrow: 1 }}
      scroll={{ x: "max-content" }}
      rowKey={(row) => row.id}
      pagination={{
        current: filters.page,
        pageSize: filters.pageSize,
        total: totalItems,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
      }}
      onChange={handleTableChange}
      loading={isLoading}
    />
  );
}

export default TableDeclarations;
